import { ThemeUICSSObject } from 'theme-ui';

export enum LINK_VARIANTS {
  primary = 'primary',
  text = 'text',
}

export const links = {
  primary: {
    color: 'primary',
    ':active': {
      color: 'blueScale.4',
    },
  } as ThemeUICSSObject,
  text: {
    color: 'text',
    display: 'inline !important',
  } as ThemeUICSSObject,
  nav: {
    transition: 'color 0.1s ease-in-out',
    textDecoration: 'none',
    display: 'flex',
    gap: [0, null, null, 1],
    width: 'full',
    fontSize: 'xs',
    padding: 0,
    flexDirection: ['column', null, null, 'row'],
    flexShrink: 0,
    overflow: 'hidden',
    height: '50px',
    color: 'greyScale.4',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'background',
    fontFamily: 'body',
    fontWeight: 'medium',
    lineHeight: 'body',
    ':focus': {
      outlineOffset: -2,
      outlineColor: 'primary',
    },
    svg: {
      height: 24,
      width: 24,
    },
  } as ThemeUICSSObject,
};
